import { useCallback, useEffect, useState } from 'react';
import AppContentContainer from '../app-content-container/AppContentContainer';
import { Select } from 'antd';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import moment from 'moment';
import styles from './AppSellingHours.module.scss';
import classnames from 'classnames';
import Link from 'next/link';
import DateIcon from '@public/images/Date.png';
import { toLower } from 'lodash';

type Props = {
    pageData: any;
    routerPath: string[];
};

const AppSellingHours = ({ pageData, routerPath }: Props) => {
    // const router = useRouter();
    // const [data, setData] = useState([]);
    // const [selectedOption, setSelectedOption] = useState('FootballFixedOddsBetting');
    const { t, i18n } = useTranslation();
    // const [rootKeys, setRootKeys] = useState([] as string[]);
    // const [options, setOptions] = useState([]);
    // const [tableDatas, setTableDatas] = useState({} as any);
    // const [title, setTitle] = useState('');

    // const getRootKeys = useCallback(() => {
    //     let keys: any = [];
    //     let options: any = [];
    //     let tables: any = {};
    //     pageData.Content.data.forEach((i: any) => {
    //         keys.push(i.key);
    //         options.push({ label: i.datasetDisplayName.value, value: i.key });
    //         tables[i.key] = i.data;
    //     });
    //     setRootKeys(keys);
    //     setOptions(options);
    //     setTableDatas(tables);
    // }, [pageData.Content.data]);

    // useEffect(() => {
    //     getRootKeys();
    // }, [getRootKeys, pageData.Content.data, router.query.data, selectedOption]);

    // useEffect(() => {
    //     tableDatas[selectedOption] && setData(tableDatas[selectedOption]);
    // }, [selectedOption, tableDatas]);
    // useEffect(() => {
    //     const s = location.search.slice(1).split('&')[0];
    //     if (s && s.split('=')[0] == 'data' && rootKeys.includes(s.split('=')[1])) {
    //         setSelectedOption(s.split('=')[1]);
    //     } else {
    //         setSelectedOption(rootKeys[0]);
    //         router.replace(
    //             {
    //                 pathname: 'info/football/selling-hours',
    //                 query: { data: rootKeys[0] },
    //             },
    //             undefined,
    //             { shallow: true }
    //         );
    //     }
    //     options.forEach((o: any) => {
    //         if (o.value === selectedOption) {
    //             setTitle(o.label);
    //         }
    //     });
    // }, [options, rootKeys, router, selectedOption]);

    // const onChangeOption = (value: string) => {
    //     setSelectedOption(value);
    //     console.log(rootKeys, value);
    //     router.replace(
    //         {
    //             pathname: 'info/football/selling-hours',
    //             query: { data: value },
    //         },
    //         undefined,
    //         { shallow: true }
    //     );
    // };

    return (
        <AppContentContainer
            routerPaths={routerPath}
            title={pageData.Content.data[0].datasetDisplayName.value}
        >
            {/* <div className='bg-[#e7e7e7] h-[56px] relative'>
                <Select
                    className='w-[230px] absolute right-[12px] top-[12px]'
                    options={options}
                    onChange={onChangeOption}
                    value={selectedOption}
                />
            </div> */}
            {
                <>
                    <table className={styles['special-selling-hours-header']}>
                        <tbody>
                            <tr className={styles.header}>
                                <td width={'10%'}>{t('SellingHours.Date')}</td>
                                <td width={'13%'}> {t('SellingHours.MatchDate')}</td>
                                <td width={'14%'}>{t('SellingHours.DigitalChannel')}</td>
                                <td width={'19%'}>
                                    <Link href={'/retail-and-telebet/telephone-betting/'}>
                                        {t('SellingHours.Telebet')}
                                    </Link>
                                    {/* <span className={styles.remark}>2</span> */}
                                </td>
                                <td width={'19.2%'}>{t('SellingHours.TelebetAutomated')}</td>
                                <td width={'12.2%'}>
                                    <Link
                                        href={
                                            i18n.language === 'zh-HK'
                                                ? 'https://entertainment.hkjc.com/entertainment/chinese/ocbb/index.aspx'
                                                : 'https://entertainment.hkjc.com/entertainment/english/ocbb/index.aspx'
                                        }
                                    >
                                        {t('SellingHours.Branch')}
                                    </Link>
                                     {/*<span className={styles.remark}>1</span>*/}
                                </td>
                                <td>{t('SellingHours.Racecourses')}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div className={styles.SellingHoursContent}>
                        <table className={styles['special-selling-hours-table']}>
                            <thead>
                                <tr className={classnames(styles['header'], 'header')}>
                                    <td width={'10%'} className={styles['fixed-left']}>
                                        {t('SellingHours.Date')}
                                    </td>
                                    <td width={'13%'}> {t('SellingHours.MatchDate')}</td>
                                    <td width={'14%'}>{t('SellingHours.DigitalChannel')}</td>
                                    <td width={'19%'}>
                                        <Link href={'/retail-and-telebet/telephone-betting/'}>
                                            {t('SellingHours.Telebet')}
                                        </Link>
                                        {/*  <span className={styles.remark}>2</span> */}
                                    </td>
                                    <td width={'19.2%'}>{t('SellingHours.TelebetAutomated')}</td>
                                    <td width={'12.2%'}>
                                        <Link
                                            href={
                                                i18n.language === 'zh-HK'
                                                    ? 'https://entertainment.hkjc.com/entertainment/chinese/ocbb/index.aspx'
                                                    : 'https://entertainment.hkjc.com/entertainment/english/ocbb/index.aspx'
                                            }
                                        >
                                            {t('SellingHours.Branch')}
                                        </Link>
                                       {/* <span className={styles.remark}>1</span> */}
                                    </td>
                                    <td>{t('SellingHours.Racecourses')}</td>
                                </tr>
                            </thead>
                            <tbody>
                                {pageData.Content.data[0].data.map((d: any) => {
                                    return (
                                        <tr
                                            key={d.key}
                                            className={classnames(
                                                moment(d.date.value).format('DD/MM') ===
                                                    moment().format('DD/MM') && styles.active
                                            )}
                                        >
                                            <td className={styles['fixed-left']}>
                                                {moment(d.date.value).format('DD/MM')}{' '}
                                                {t(
                                                    `SellingHours.${moment(d.date.value).format(
                                                        'ddd'
                                                    )}`
                                                )}
                                            </td>
                                            <td>
                                                {d.matchDate.value == 1 && (
                                                    <div className={styles['date-icon']}></div>
                                                )}
                                            </td>
                                            <td>{d.digitalChannel.value}</td>
                                            <td>{d.telebet.value}</td>
                                            <td>{d.telebetAutomated.value}</td>
                                            <td>{d.branch.value}</td>
                                            <td>{d.racecourses.value}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>

                        {/* <Table
                        columns={columns}
                        dataSource={data}
                        pagination={false}
                        scroll={{ x: 1024, y: 1920 }}
                    /> */}
                    </div>
                </>
            }
            <div
                className={styles.footnote}
                dangerouslySetInnerHTML={{ __html: pageData?.Content?.footnote.value }}
            ></div>
        </AppContentContainer>
    );
};

export default AppSellingHours;
